export enum CardFocusType {
    CardNumber = 'number',
    Name = 'name',
    Expiration = 'expiry',
    CVC = 'cvc',
}
